import '../styles/Footer.css';
import React from 'react';

function Footer() {
  return (
    <footer className="mtrx-footer" aria-labelledby="mtrx-footer-name">
      <svg
        className="mtrx-footer__arc"
        viewBox="0 0 1200 46"
        preserveAspectRatio="none"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M 4 42 C 300 22, 600 4, 1196 30" strokeWidth="2.5" />
        <path d="M 4 42 C 300 22, 600 4, 1196 30" strokeWidth="1" opacity="0.35" transform="translate(0 4)" />
      </svg>
      <div className="mtrx-footer__band">
        <div className="mtrx-footer__rail" data-content-rail="primary">
          <div className="mtrx-footer__identity">
            <p className="mtrx-footer__mark" id="mtrx-footer-name">
              Montreaux
              <span className="mtrx-footer__mark-rule" aria-hidden="true" />
            </p>
          </div>
          <p className="mtrx-footer__context">
            Montreaux is a simple loan service for everyday applicants.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;